import { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { closeDeleteTranslationDocument, closeEditTranslationDocument, fetchDocuments, openDeleteTranslationDocument, openEditTranslationDocument, resetTabState, updateRequestBody } from "../../../redux/EngageTranslation/EngageTranslationAction";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import TableComponent from "../../TableComponent/TableComponent";
import ConfirmDeleteModal from "../Modal/ConfirmDeleteModal";
import EditDocumentInfoModal from "../Modal/EditDocumentInfoModal";
import EngageTranslationNewTableColumns from "../TableComponent/EngageTranslationNewTableColumns";

function NewTabContent(props: any) {
  const dispatch = useAppDispatch();
  const newTabState = useSelector((state: RootState) => state.engageTranslationState.newTabState);
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }
      return false;
    };
    const newSortingRequestBody = { ...newTabState.currentRequestBody, sortColumn: sorter.field, isAsc: isAscend(sorter.order) };
    dispatch(resetTabState("new"));

    dispatch(updateRequestBody({ requestBody: newSortingRequestBody, view: "new" }));

    dispatch(fetchDocuments({ view: "new" }));
  };

  return (
    <div className="d-flex flex-column full-flex h-100 mt-2 px-2 overflow-hidden">
      <ConfirmDeleteModal
        open={() => dispatch(openDeleteTranslationDocument())}
        close={() => dispatch(closeDeleteTranslationDocument())}
        openState={newTabState.deleteTranslationDocumentOpenSate}
      />
      <EditDocumentInfoModal
        open={() => dispatch(openEditTranslationDocument())}
        close={() => dispatch(closeEditTranslationDocument())}
        openState={newTabState.editTranslationDocumentOpenSate}
      />

      <div className="d-flex flex-column full-flex gap-3 overflow-hidden">
        <TableComponent
          dataSource={newTabState.data}
          tableKey={"new"}
          columns={EngageTranslationNewTableColumns}
          handleTableSorting={handleTableSorting}
          pagination={newTabState.pagination}
          loading={newTabState.loading}
        />
      </div>
    </div>
  );
}

export default memo(NewTabContent);
